<template>
  <auth-layout>
    <div class="c-auth-card c-signup-card">
      <div class="c-auth-card__head">
        <img src="@/assets/img/logo.svg" class="logo" alt="Sber logo">
      </div>
      <div class="c-auth-card__content">
        <div class="c-auth-card__slider">
          <transition name="fadeInOut">
            <div class="c-auth-card__slide first" v-if="steps.first">
              <h2 class="c-auth-card__title last">{{$t('signup.title')}}</h2>
              <form method="post" @submit.prevent="signup">
                <div class="c-auth-card__body c-signup-card__body">
                  <form-control
                    :placeholder="payload.username.placeholder"
                    :error="payload.username.error"
                    :short="payload.username.short"
                    :type="payload.username.type"
                    :isSuccess="payload.username.isSuccess"
                    v-model="payload.username.value"
                    @input="checkFields(payload.username, 'username')"
                    required
                    autofocus
                  />
                  <form-control
                    :placeholder="payload.password.placeholder"
                    :error="payload.password.error"
                    :short="payload.password.short"
                    :type="payload.password.type"
                    :isSuccess="payload.password.isSuccess"
                    :iconType="payload.password.iconType"
                    :iconClick="togglePassword"
                    v-model="payload.password.value"
                    @input="checkFields(payload.password, 'password')"
                    required
                  />
                  <form-control
                    :placeholder="payload.repeat_password.placeholder"
                    :error="payload.repeat_password.error"
                    :short="payload.repeat_password.short"
                    :type="payload.repeat_password.type"
                    :isSuccess="payload.repeat_password.isSuccess"
                    v-model="payload.repeat_password.value"
                    @input="checkFields(payload.repeat_password, 'repeat_password')"
                    required
                  />
                </div>

                <div class="c-auth-card__controlls c-signup-card__controlls">
                  <button type="submit" class="button button__bold" :disabled="!firstSuccess">{{$t('ui.continue')}}</button>
                  <router-link to="/login" class="link link__ui">{{$t('ui.cancel')}}</router-link>
                </div>
              </form>
            </div>
          </transition>
          <transition name="rollUp">
            <div class="c-auth-card__slide second" v-if="steps.second">
              <h2 class="c-auth-card__title">{{$t('signup.continue')}}</h2>
              <p class="c-auth-card__short">На номер телефона +7 (981) 342-XX-XX был выслан SMS-код подтверждения</p>
              <form method="post" @submit.prevent="smsCheckMethod">
                <div class="c-auth-card__body c-signup-card__body">
                  <form-control
                    :placeholder="smsCheck.placeholder"
                    :error="smsCheck.error"
                    :short="smsCheck.short"
                    :type="smsCheck.type"
                    v-model="smsCheck.value"
                    @input="checkSmsField"
                    required
                    autofocus
                  />
                  <button type="button" class="c-signup-card__resend" @click="repeatSmsCode()">
                    <img src="@/assets/img/icons/repeat.svg" alt="">
                    <span>Выслать код повторно</span>
                  </button>
                </div>

                <div class="c-auth-card__controlls c-signup-card__controlls">
                  <button type="submit" class="button button__bold" :disabled="!secondSuccess">{{$t('ui.continue')}}</button>
                  <span to="/login" class="link link__ui" @click="backToFirst()">{{$t('ui.cancel')}}</span>
                </div>
              </form>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </auth-layout>
</template>
<script>
import AuthLayout from "@/layouts/AuthLayout";
import FormControl from "@/components/forms/FormControl";

export default {
  data() {
    return {
      steps: {
        first: true,
        second: false
      },
      firstSuccess: false,
      secondSuccess: false,
      payload: {
        username: {
          value: "",
          short: "",
          error: "",
          isSuccess: false,
          placeholder: "signup.username",
          type: "tel"
        },
        password: {
          value: "",
          short: "",
          error: "",
          isSuccess: false,
          placeholder: "signup.password",
          type: "password",
          iconType: "password"
        },
        repeat_password: {
          value: "",
          short: "",
          error: "",
          isSuccess: false,
          placeholder: "signup.password",
          type: "password"
        }
      },
      smsCheck: {
        value: "",
        short: "",
        error: "",
        placeholder: "signup.smscode",
        type: "text"
      }
    };
  },
  components: {
    AuthLayout,
    FormControl
  },
  methods: {
    togglePassword(data) {
      if (data.click) {
        if (this.payload.password.type === "password") {
          this.payload.password.type = "text";
        } else {
          this.payload.password.type = "password";
        }
      }
    },
    checkFields(field, type) {
      if (field.value.length < 1) {
        field.error = "Поле не может быть пустым";
        field.isSuccess = false;
      } else {
        field.error = "";
        field.isSuccess = true;
      }

      if (type === "password" || type === "repeat_password") {
        this.confirmPassword();
      }

      if (
        this.payload.username.isSuccess &&
        this.payload.password.isSuccess &&
        this.payload.repeat_password.isSuccess
      ) {
        this.firstSuccess = true;
      } else {
        this.firstSuccess = false;
      }
    },
    confirmPassword() {
      if (this.payload.repeat_password.value !== this.payload.password.value) {
        this.payload.repeat_password.error = "Пароли не совпадают";
        this.payload.password.error = "Пароли не совпадают";

        this.payload.repeat_password.isSuccess = false;
        this.payload.password.isSuccess = false;
      } else {
        this.payload.repeat_password.error = "";
        this.payload.password.error = "";

        this.payload.repeat_password.isSuccess = true;
        this.payload.password.isSuccess = true;
      }
    },
    signup() {
      this.steps.first = false;
      this.steps.second = true;
    },
    checkSmsField() {
      if (this.smsCheck.value.length > 3) {
        this.secondSuccess = true;
      } else {
        this.secondSuccess = false;
      }
    },
    backToFirst() {
      this.smsCheck.value = "";
      this.steps.second = false;
      this.steps.first = true;
    },
    smsCheckMethod(e) {
      console.log(this.smsCheck, e, "checkSms");
    },
    repeatSmsCode() {
      console.log("repeat sms");
    }
  }
};
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}
</style>
